import { AssistanceEquipment } from "@edp-models/assistance-equipment.model";
import { AssistanceRequestList } from "@edp-models/assistance-request.model";

export interface IAssistanceRequestState {
    assistanceRequest: Array<AssistanceRequestList>;
    equipments: Array<AssistanceEquipment>;
}

export const initialAssistanceRequestState: IAssistanceRequestState = {
    assistanceRequest: null,
    equipments: null,
};
